let _sideBarRequestHandler = false
module.exports = {
	IframeUrl: () => {
		const windowUrl = window.location.search
		const params = new URLSearchParams(windowUrl)
		const msa = params.get("msa") == null ? "common" : params.get("msa").replace(/[0-9]/g, "")
		const depth = params.get("depth") == null ? "depth" : params.get("depth")
		const path = params.get("path") == null ? "path" : params.get("path")
		let msaUrl = "https://api-" + msa + ".x2bee.com/api/" + msa + "/swagger-ui/index.html#/" + depth
		if (params.get("path") != null) {
			msaUrl = msaUrl + "/" + path
		}
		return msaUrl
	},
	CsvUrl: (modulsName, tag, operationId) => {
		return "http://api.x2bee.com/content?msa=" + modulsName + "&depth=" + tag + "&path=" + operationId
	},
	SideBarRequestHandler: () => {
		return _sideBarRequestHandler
	},
	OpenRequest: (flag) => {
		_sideBarRequestHandler = flag
	},
	OpenIndex: (modulsName) => {
		switch (modulsName) {
			case "common":
				return 1
			case "display":
				return 2
			case "event":
				return 3
			case "goods":
				return 4
			case "member":
				return 5
			case "order":
				return 6
			default:
				return 0
		}
	},
	getJsonPathMap: (jsonData, jp) => {
		const names = jp.query(jsonData, "$..paths")
		return Object.entries(
			jp.nodes(names, "$..tags").reduce((acc, { path, value, group }) => {
				let names = value.toString()
				let paths = path[2].toString()
				acc[names] = acc[names] || []
				acc[names].push({ names, paths })
				return acc
			}, {})
		).map(([key, value]) => ({ name: key, path: value }))
	},
	getParams: () => {
		const windowUrl = window.location.search
		return new URLSearchParams(windowUrl)
	},
	HandleMoMenu: (target) => {
		const getSiblings = (cn) => {
			let s = []
			let pn = cn.parentNode
			let sn = pn.firstChild
			while (sn) {
				if (sn.nodeType === 1 && sn !== cn) {
					s.push(sn)
				}
				sn = sn.nextElementSibling
			}
			return s
		}
		const currentTarget = target.currentTarget
		const onoff = currentTarget.getAttribute("data-onoff") == "on" ? "off" : "on"
		const nodes = getSiblings(currentTarget)
		let count = 0
		while (count < nodes.length) {
			nodes[count].classList.remove("on", "off")
			nodes[count].classList.add(onoff)
			count++
		}
		currentTarget.setAttribute("data-onoff", onoff)
	},
	HandlePage: (param, target) => {
		if (target == null || target.target.closest(".m_menu") == null) {
			document.getElementsByClassName("m_menu")[0].querySelector("#hamburger").checked = false
		}
	},
}
